import { render, staticRenderFns } from "./EditShipping.vue?vue&type=template&id=a0056b5a&scoped=true"
import script from "./EditShipping.vue?vue&type=script&lang=js"
export * from "./EditShipping.vue?vue&type=script&lang=js"
import style0 from "./EditShipping.vue?vue&type=style&index=0&id=a0056b5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0056b5a",
  null
  
)

export default component.exports